/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".set-page-tag-modal ig-field input{width:calc(100% - 40px)}.set-page-tag-modal ig-field mat-icon{bottom:19px}.set-page-tag-modal .dialog-content{margin-top:16px}.set-page-tag-modal .action-row{-webkit-box-orient:horizontal;-webkit-box-direction:reverse;-ms-flex-direction:row-reverse;flex-direction:row-reverse;margin-top:12px}"];
export { styles as styles };



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/admin/accounts/event.spider/set.eventpage.tag.modal/set.eventpage.tag.modal.component.scss.ngstyle.js.pre-build-optimizer.js